import type { Moment } from "moment/moment";
import type { KubernetesLiveResourceHealthStatusCode, KubernetesLiveResourceSyncStatusCode } from "./kubernetesLiveResourceStatusCode";
export type BaseKubernetesLiveStatusDetailedResource = {
    Name: string;
    Namespace?: string;
    Kind: string;
    HealthStatus: KubernetesLiveResourceHealthStatusCode;
    SyncStatus: KubernetesLiveResourceSyncStatusCode | null;
    MachineId: string;
    LastUpdated: Moment;
    ManifestSummary?: ManifestSummaryResource;
    Children: KubernetesLiveStatusDetailedResource[];
    DesiredResourceId?: string;
    ResourceId?: string;
};
export type KubernetesPodLiveStatusDetailedResource = Omit<BaseKubernetesLiveStatusDetailedResource, "Details"> & {
    Kind: "Pod";
    ManifestSummary: PodManifestSummaryResource;
};
export type KubernetesLiveStatusDetailedResource = BaseKubernetesLiveStatusDetailedResource | KubernetesPodLiveStatusDetailedResource;
export type ManifestSummaryResource = {
    Labels: Record<string, string>;
    Annotations: Record<string, string>;
    CreationTimestamp: Moment;
};
export type PodManifestSummaryResource = ManifestSummaryResource & {
    Containers: string[];
};
export function isPodResource(resource: BaseKubernetesLiveStatusDetailedResource | undefined): resource is KubernetesPodLiveStatusDetailedResource {
    return resource?.Kind === "Pod";
}
